import { Backdrop } from '@material-ui/core';
import { motion } from 'framer-motion';
import { Car } from 'lucide-react';
import { useThemeContext } from 'shared/context/themeContext';
import { dark as darkColors, light as lightColors } from 'shared/theme/colorTokens';

interface Props {
  isVisible: boolean;
}

const TRACK_WIDTH = 240;
const TRACK_HEIGHT = 15;
const CAR_SIZE = 30;
const LAP_DURATION = 1.6;

// Reemplaza el `Spinner` de `@vadiun/react-components` (no se puede
// restylear directo, vive en node_modules) — mismo contrato de props
// (`{ isVisible: boolean }`) para poder pasarse tal cual a
// `SpinnerProvider`/`LegacySpinnerProvider` en `App.tsx`.
//
// El auto de `ThemeToggleButton` avanza de izquierda a derecha sobre una
// pista horizontal, dejando detrás una barra cyan gruesa (como una barra
// de progreso) que crece en sincro con su posición — al llegar al final
// ambos vuelven a 0 y arrancan de nuevo. Sin texto ni card, solo la pista
// flotando sobre el backdrop.
const AppSpinner = ({ isVisible }: Props) => {
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';
  const colors = isDark ? darkColors : lightColors;
  const travel = TRACK_WIDTH - CAR_SIZE;

  return (
    <Backdrop
      open={isVisible}
      style={{ zIndex: 1000, backgroundColor: colors.overlay }}
    >
      <div
        key={String(isVisible)}
        className="relative overflow-hidden rounded-full bg-white/20"
        style={{ width: TRACK_WIDTH, height: TRACK_HEIGHT }}
      >
        <div style={{ width: travel }}>
        <motion.div
          className="absolute inset-y-0 left-0 rounded-full"
          style={{ backgroundColor: colors.accent, boxShadow: isDark ? colors.glow : 'none' }}
          animate={{ width: [0, travel] }}
          transition={{ duration: LAP_DURATION, repeat: Infinity, ease: 'easeInOut' }}
        />
        </div>
        <motion.div
          className="absolute top-1/2"
          style={{ y: '-50%' }}
          animate={{ x: [0, travel] }}
          transition={{ duration: LAP_DURATION, repeat: Infinity, ease: 'easeInOut' }}
        >
          <Car size={CAR_SIZE} style={{ color: colors.accent }} />
        </motion.div>
      </div>
    </Backdrop>
  );
};

export default AppSpinner;
